<template>
   <hic-dialog append-to-body @open="open" :close-on-click-modal="false" :visible="visible" width="70%" title="检治项目编辑" @close="cancel">
    
    <el-form :model="examineItem" :rules="comRules" ref="editor" label-width="5rem" label-position="right" style="padding-right: 3rem">
      <el-row>
        <el-col :span="8">
          <el-form-item label="名称" prop="name">
            <el-select style="width: 100%" size="small" v-model="examineItem.standardCode" filterable remote reserve-keyword placeholder="请输入关键词" :remote-method="remoteMethod" :loading="loading" @change="change">
              <el-option v-for="item in therapy" :key="item.code" :label="item.name" :value="item.code"> </el-option>
            </el-select>
            <!-- <el-input type="text" size="small" placeholder="请输入名称" v-model.trim="examineItem.name"/> -->
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="执行科室" prop="execDeptCode">
            <hic-dict-selector v-model="examineItem.execDeptCode" placeholder="请选择" dict-type="Dept" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="备注" prop="memo">
            <el-input size="small" type="text" placeholder="请输入备注" v-model="examineItem.memo" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cancel">关 闭</el-button>
      <el-button type="primary" @click="save" :disabled="disabledSave">确 定</el-button>
    </div>
  </hic-dialog>

</template>

<script>
  import api from "./api";
  import { mapGetters } from "sw-hic";
  export default {
    props: {
      visible: Boolean,
      examineItem: Object,
    },
    data() {
      return {
        loading: false,
        therapy: [],
        origin: null,
        typeLoding: false,
        condition: {
          pageIndexOnView: 1,
          pageSize: 99999,
        },

        comRules: {
          deptCode: [
            {
              required: true,
              message: "请输入编码",
              trigger: "blur",
            },
          ],
          name: [
            {
              required: true,
              message: "请输入名称",
              trigger: "blur",
            },
          ],
          srcType: [
            {
              required: true,
              message: "请选择项目源类型",
              trigger: "blur",
            },
          ],
          srcCode: [
            {
              required: true,
              message: "请输入项目源编码",
              trigger: "blur",
            },
          ],
          mnemonic: [
            {
              required: true,
              message: "请输入助记符",
              trigger: "blur",
            },
          ],
        },
        disabledSave: false,
        synDisabledSave: false,
        deptFilterKey: null,
      };
    },
    computed: {
      ...mapGetters(["dict", "user", "dictEnum", "Enum"]),
    },
    created() {
      this.typeLoding = false;
      this.showEditor = true;
    },
    methods: {
      change(code) {
        let item = this.therapy.find((item) => item.code == code);
        let { name, price } = item;
        this.examineItem.name = name;
        this.examineItem.price = price;
      },
      remoteMethod(name) {
        api.SetDetailId.query({ keyword: name }).then((res) => {
          this.therapy = res.items;
        });
      },
      open() {},

      cancel() {
        this.$emit("update:visible", false);
        this.$emit("cancel");
      },
      del: function (row, index) {
        let _this = this;
        api.delItem(row.id).then((res) => {
          _this.entities.items.splice(index, 1, {});
          _this.$message.success("删除成功！");
        });
      },

      save() {
        this.$refs.editor.validate().then((valid) => {
          if (valid) {
            this.disabledSave = true;
            api
              .TherapyItem.query(this.examineItem)
              .then((res) => {
                this.$message.success("保存成功!");
                this.$emit("ok");
                this.cancel();
              })
              .catch((err) => {
                this.$message.error(err);
              })
              .finally(() => {
                this.disabledSave = false;
              });
          }
        });
      },
    },
  };
</script>

<style scoped>
  .flex {
    display: flex;
    justify-content: center;
  }
</style>
